/* LBDH, configurateur de coffret (montre + bracelet).
   Lit le JSON pose par la section, pilote les 4 etapes, et synchronise le
   <select name="id"> natif : c'est lui qui part au panier, pas un etat maison.

   AUCUN ANTISLASH dans ce fichier, et c'est volontaire. Il est ecrit via
   themeFilesUpsert, dont les blocs de chaine GraphQL laissent les antislashs
   tels quels : une sequence d'echappement tapee a la main ressort doublee dans
   le fichier servi, et une apostrophe echappee dans une chaine simple quote
   casse tout le script. D'ou [0-9] plutot qu'un raccourci de classe, des
   guillemets doubles partout ou il y a une apostrophe, et la plage des signes
   diacritiques construite avec String.fromCharCode plutot qu'avec une sequence
   unicode echappee. */
(function () {
  var root = document.querySelector('[data-lbdh-cfg]');
  if (!root) return;
  var raw = root.querySelector('[data-lbdh-cfg-data]');
  if (!raw) return;

  var DATA;
  try { DATA = JSON.parse(raw.textContent); } catch (e) { return; }

  var priceCents = parseInt(root.getAttribute('data-price'), 10) || 0;
  function money(cents) { return (cents / 100).toFixed(2).replace('.', ',') + ' €'; }

  /* En dessous de ce seuil, l'economie affichee dessert l'offre : annoncer
     "vous economisez 2,90 €" sur un coffret a 99,90 € donne l'impression qu'il
     n'y a pas d'avantage a le prendre. On masque alors toute la ligne de valeur
     plutot que d'afficher un argument faible. */
  var ECO_MINI = 500;

  var FLECHE_BAS = '<svg viewBox="0 0 16 16" width="11" height="11" aria-hidden="true" focusable="false">' +
    '<path d="M8 3v9M4.5 8.5 8 12l3.5-3.5" fill="none" stroke="currentColor" stroke-width="1.5" ' +
    'stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var FLECHE_HAUT = '<svg viewBox="0 0 16 16" width="11" height="11" aria-hidden="true" focusable="false">' +
    '<path d="M8 13V4M4.5 7.5 8 4l3.5 3.5" fill="none" stroke="currentColor" stroke-width="1.5" ' +
    'stroke-linecap="round" stroke-linejoin="round"/></svg>';

  var sel = root.querySelector('[data-lbdh-select]');
  var ctas = root.querySelectorAll('[data-lbdh-cta]');
  var ctaLabels = root.querySelectorAll('[data-lbdh-cta-label]');
  var hint = root.querySelector('[data-lbdh-sheets-hint]');
  var recap = root.querySelector('[data-lbdh-recap]');
  var recapLis = recap ? recap.querySelectorAll('li') : [];
  var valueRow = recap ? recap.querySelector('.lbdh-cfg__value') : null;
  var vignetteM = root.querySelector('[data-lbdh-sticky-img="montre"]');
  var vignetteB = root.querySelector('[data-lbdh-sticky-img="bracelet"]');
  var gravZone = root.querySelector('[data-lbdh-grav]');
  var gravInput = root.querySelector('[data-lbdh-grav-input]');
  var tailleZone = root.querySelector('[data-lbdh-taille]');
  var tailleSelect = root.querySelector('[data-lbdh-taille-input]');
  var tailleUnique = root.querySelector('[data-lbdh-taille-unique]');
  var tailleNote = root.querySelector('[data-lbdh-taille-note]');
  var tailleSpecs = root.querySelector('[data-lbdh-taille-specs]');
  var steps = {};
  root.querySelectorAll('[data-step]').forEach(function (el) { steps[el.getAttribute('data-step')] = el; });

  /* La barre collante est etroite. On repere ses libelles une bonne fois pour
     leur donner un texte court : le prix y est deja affiche a cote du bouton,
     et le libelle long ("Ajouter ce coffret 99,90 €") faisait deborder le
     bouton sur le recapitulatif, prix casse sur deux lignes et titre tronque.
     Pour la meme raison le recapitulatif n'annonce QUE les deux pieces : y
     ajouter l'option cochee tronquait la ligne et faisait perdre les deux
     informations a la fois. C'est le prix, passe au total, qui signale
     l'option. */
  var stickyBar = root.querySelector('[data-lbdh-sticky]');
  var stickyPrix = stickyBar ? stickyBar.querySelector('.lbdh-cfg__stickytxt strong') : null;
  var ctaLabelsCourts = stickyBar ? stickyBar.querySelectorAll('[data-lbdh-cta-label]') : [];
  function estCourt(el) {
    for (var i = 0; i < ctaLabelsCourts.length; i++) {
      if (ctaLabelsCourts[i] === el) return true;
    }
    return false;
  }

  /* Barre collante sur ordinateur. Sous 900 px le CSS l'affiche en permanence
     et ce code n'y change rien. Au-dessus, elle n'apparait que lorsque le
     bouton principal n'est pas a l'ecran : la colonne de droite est longue, et
     un visiteur qui lit les fiches detail ou la description n'a plus de bouton
     sous les yeux. Tant que le bouton principal est visible, pas de barre,
     pour ne jamais montrer deux boutons identiques en meme temps. */
  var ctaPrincipal = root.querySelector('.lbdh-cfg__form .lbdh-cfg__cta');
  if (stickyBar && ctaPrincipal && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entrees) {
      stickyBar.classList.toggle('is-pc-visible', !entrees[0].isIntersecting);
    }).observe(ctaPrincipal);
  }

  /* Bandeau cookies. L'app de consentement pose son bandeau (.cc-window
     .cc-bottom) en bas de l'ecran, au-dessus de tout : il cachait la barre
     collante tant que le visiteur n'avait pas fait son choix. On remonte la
     barre de la hauteur du bandeau tant qu'il est affiche ; elle redescend des
     qu'il se ferme, quel que soit le choix (accepter, refuser, preferences).
     Le bandeau arrive apres ce script : on surveille son insertion dans le
     body, puis ses changements de classe et de style. */
  function hauteurBandeau() {
    var b = document.querySelector('.cc-window.cc-bottom');
    if (!b || b.classList.contains('cc-invisible')) return 0;
    var cs = getComputedStyle(b);
    if (cs.display === 'none' || cs.visibility === 'hidden' || cs.position !== 'fixed') return 0;
    var r = b.getBoundingClientRect();
    if (!r.height || r.bottom < window.innerHeight - 2) return 0;
    return Math.round(r.height);
  }
  var bandeauSuivi = null;
  function calerSurBandeau() {
    var h = hauteurBandeau();
    stickyBar.style.bottom = h ? h + 'px' : '';
    var b = document.querySelector('.cc-window.cc-bottom');
    if (b && b !== bandeauSuivi) {
      bandeauSuivi = b;
      var suivi = { attributes: true, attributeFilter: ['class', 'style'] };
      new MutationObserver(calerSurBandeau).observe(b, suivi);
      if (b.parentElement) new MutationObserver(calerSurBandeau).observe(b.parentElement, suivi);
    }
  }
  if (stickyBar && 'MutationObserver' in window) {
    calerSurBandeau();
    new MutationObserver(calerSurBandeau).observe(document.body, { childList: true });
    window.addEventListener('resize', calerSurBandeau);
  }

  // Garde-fou : une combinaison sans variante serait invendable en silence.
  var orphelines = 0;
  DATA.montres.forEach(function (m) {
    m.finitions.forEach(function (a) {
      DATA.bracelets.forEach(function (b) {
        b.finitions.forEach(function (c) {
          if (!DATA.variants[a.opt + '||' + c.opt]) orphelines++;
        });
      });
    });
  });
  if (orphelines) {
    console.warn("[LBDH coffret] " + orphelines + " combinaison(s) sans variante. " +
      "Verifiez que le libelle de chaque bloc correspond au prefixe des valeurs d'option.");
  }

  root.querySelectorAll('.lbdh-cfg__fallback').forEach(function (n) {
    n.classList.remove('lbdh-cfg__fallback');
    n.classList.add('lbdh-cfg__sronly');
  });
  ctas.forEach(function (b) { b.disabled = true; });

  var state = { mModel: null, mFin: null, bModel: null, bFin: null };
  // Vignette de chaque carte modele, pour la faire suivre la finition choisie.
  var vignettesCartes = { montre: {}, bracelet: {} };

  // Les URL du CDN Shopify acceptent un parametre width : on redemande la meme
  // image a la taille voulue plutot que de servir 1400 px dans une vignette.
  function aLargeur(u, w) {
    if (!u) return u;
    if (u.indexOf('width=') !== -1) return u.replace(/([?&])width=[0-9]+/, '$1width=' + w);
    return u + (u.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  }

  /* ---------------- Lightbox ---------------- */
  var lb = root.querySelector('[data-lbdh-lightbox]');
  var lbImg = root.querySelector('[data-lbdh-lightbox-img]');
  function ouvrirLightbox(src, alt) {
    if (!lb || !lbImg || !src) return;
    lbImg.src = aLargeur(src, 1800);
    lbImg.alt = alt || '';
    lb.hidden = false;
  }
  function fermerLightbox() { if (lb) { lb.hidden = true; lbImg.removeAttribute('src'); } }
  if (lb) {
    root.querySelector('[data-lbdh-lightbox-close]').addEventListener('click', fermerLightbox);
    lb.addEventListener('click', function (e) { if (e.target === lb) fermerLightbox(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !lb.hidden) fermerLightbox(); });
  }

  /* ---------------- Apercu du coffret compose ----------------
     L'image principale montre les DEUX pieces dans la boite, pas la montre a
     cote du bracelet. Il existe une photo par combinaison, 240 au total, posees
     dans Contenu > Fichiers. Aucune table n'est embarquee dans la page : le nom
     du fichier se deduit des deux valeurs d'option choisies.

         "Armand · Argent Blanc" + "Cuir personnalise · Or"
         -> coffret-armand-argent-blanc--cuir-personnalise-or.jpg

     normaliser() applique exactement la regle qui a servi a nommer les 240
     fichiers : decomposition NFD, signes diacritiques retires, minuscules,
     toute suite de caracteres qui n'est ni lettre ni chiffre devient un tiret.
     Ajouter une finition ne demande donc aucune ligne de code, seulement dix
     fichiers de plus au bon nom.

     Si un fichier manque, l'evenement error fait basculer l'image sur le
     packshot de la montre : une combinaison non encore photographiee degrade
     l'apercu au lieu de laisser un cadre casse. */
  var hero = root.querySelector('[data-lbdh-hero]');
  var heroCap = root.querySelector('[data-lbdh-herocap]');
  var vues = root.querySelector('[data-lbdh-vues]');
  var BASE_IMG = root.getAttribute('data-base-img') || '';
  var DIACRITIQUES = new RegExp('[' + String.fromCharCode(768) + '-' + String.fromCharCode(879) + ']', 'g');
  var TAILLES_HERO = '(min-width: 900px) 52vw, 100vw';

  function normaliser(s) {
    var t = String(s);
    if (t.normalize) t = t.normalize('NFD').replace(DIACRITIQUES, '');
    return t.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+/, '').replace(/-+$/, '');
  }

  function urlCoffret() {
    if (!state.mFin || !state.bFin || !BASE_IMG) return '';
    return BASE_IMG + 'coffret-' + normaliser(state.mFin.opt) +
           '--' + normaliser(state.bFin.opt) + '.jpg?width=1400';
  }

  var vueActive = '';
  function poserHero(src, legende, cle) {
    if (!hero || !src) return;
    hero.removeAttribute('data-secours');
    hero.srcset = aLargeur(src, 700) + ' 700w, ' +
                  aLargeur(src, 1000) + ' 1000w, ' +
                  aLargeur(src, 1400) + ' 1400w';
    hero.sizes = TAILLES_HERO;
    hero.src = aLargeur(src, 1400);
    hero.alt = legende || '';
    if (heroCap) heroCap.textContent = legende || '';
    vueActive = cle;
    marquerVueActive();
  }

  function marquerVueActive() {
    if (!vues) return;
    vues.querySelectorAll('[data-vue]').forEach(function (b) {
      b.setAttribute('aria-current', b.getAttribute('data-vue') === vueActive ? 'true' : 'false');
    });
  }

  if (hero) {
    hero.addEventListener('click', function () { ouvrirLightbox(hero.currentSrc || hero.src, hero.alt); });
    hero.addEventListener('error', function () {
      if (hero.getAttribute('data-secours') === '1') return;
      hero.setAttribute('data-secours', '1');
      var repli = (state.mFin && state.mFin.img) || '';
      if (!repli) return;
      console.warn('[LBDH coffret] photo de combinaison absente, repli sur le packshot de la montre.');
      hero.removeAttribute('srcset');
      hero.removeAttribute('sizes');
      hero.src = repli;
    });
  }

  /* La bande de vignettes, dans cet ordre :
       1. le coffret compose, c'est lui qui porte le choix du client ;
       2. les VUES FIXES du reglage de section : la boite, la carte de
          remerciement recto et verso. Elles viennent tout de suite apres le
          coffret et non en fin de bande : en derniere position, sur telephone,
          il fallait faire defiler une vingtaine de vignettes pour decouvrir que
          la carte etait offerte, autant dire que personne ne la voyait ;
       3. les photos DE LA FINITION choisie, montre puis bracelet.
     On ne reconstruit la bande que si son contenu change reellement, sinon
     chaque refresh() ferait clignoter les images et perdrait la position de
     defilement. */
  var vuesSignature = '';
  function majApercu() {
    if (!hero) return;

    var liste = [];
    var coffret = urlCoffret();
    if (coffret) {
      liste.push({
        cle: 'coffret',
        url: coffret,
        legende: 'Montre ' + state.mModel.label + ' ' + state.mFin.label +
                 ', bracelet ' + state.bModel.label + ' ' + state.bFin.label
      });
    }
    (DATA.vuesFixes || []).forEach(function (v, i) {
      if (v && v.url) liste.push({ cle: 'f' + i, url: v.url, legende: v.legende || '' });
    });
    if (state.mModel) {
      galerieDe(state.mModel, state.mFin).forEach(function (u, i) {
        liste.push({
          cle: 'm' + i, url: u,
          legende: 'Montre ' + state.mModel.label + (state.mFin ? ' ' + state.mFin.label : '')
        });
      });
    }
    if (state.bModel) {
      galerieDe(state.bModel, state.bFin).forEach(function (u, i) {
        liste.push({
          cle: 'b' + i, url: u,
          legende: 'Bracelet ' + state.bModel.label + (state.bFin ? ' ' + state.bFin.label : '')
        });
      });
    }
    if (!liste.length) return;

    var signature = liste.map(function (v) { return v.url; }).join('|');
    if (signature === vuesSignature) { marquerVueActive(); return; }
    vuesSignature = signature;

    if (vues) {
      vues.innerHTML = '';
      liste.forEach(function (v) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'lbdh-cfg__vue';
        b.setAttribute('data-vue', v.cle);
        b.setAttribute('aria-current', 'false');
        b.setAttribute('aria-label', v.legende);
        var img = document.createElement('img');
        img.src = aLargeur(v.url, 200);
        img.alt = '';
        img.loading = 'lazy';
        img.width = 74;
        img.height = 74;
        b.appendChild(img);
        b.addEventListener('click', function () { poserHero(v.url, v.legende, v.cle); });
        vues.appendChild(b);
      });
      vues.scrollLeft = 0;
    }
    // Nouvelle combinaison : on revient toujours sur le coffret compose, c'est
    // lui que le client vient de modifier.
    poserHero(liste[0].url, liste[0].legende, liste[0].cle);
  }

  /* Les photos d'UNE finition, pas celles du produit entier. Chaque finition
     porte sa propre liste, attribuee cote Liquid d'apres le nom de fichier
     (voir lbdh-coffret-source.liquid). Avant, le carrousel deroulait toute la
     fiche source : choisir le Lucien bleu affichait aussi l'argent, le vert et
     le noir, et la bande ne montrait plus le produit que le client venait de
     composer. */
  function galerieDe(item, fin) {
    var liste = [];
    if (fin && fin.img) liste.push(fin.img);
    if (fin && fin.photos) {
      fin.photos.forEach(function (u) { if (u && liste.indexOf(u) === -1) liste.push(u); });
    }
    if (!liste.length && item.finitions[0]) liste.push(item.finitions[0].img);
    return liste;
  }

  // La vignette de la carte suit la finition : sans ca, la carte "Lucien" reste
  // sur son premier coloris alors que le client a choisi l'argent et bleu, et
  // les deux visuels de la page se contredisent.
  function majVignetteCarte(famille, label, fin) {
    var img = vignettesCartes[famille] && vignettesCartes[famille][label];
    if (img && fin && (fin.vignette || fin.img)) img.src = fin.vignette || fin.img;
  }

  /* ---------------- Taille du bracelet ----------------
     Deux etats, et le bloc n'est jamais masque une fois un bracelet choisi.
     Le jonc et la manchette n'ont qu'une taille : faire disparaitre le bloc
     laissait le client se demander s'il avait rate une etape. On bascule donc
     sur "Taille unique" + un lien vers la fiche du bas, qui porte le detail
     utile (tour de poignet, longueur de sangle).
     Le <select> est alors masque ET desactive : un controle desactive n'est pas
     soumis, donc aucune propriete vide ne part sur ces commandes.
     On ne reconstruit la liste que lorsque le modele change, sinon chaque
     refresh() ecraserait le choix du client. */
  var tailleModele = null;
  function majTaille() {
    if (!tailleZone || !tailleSelect) return;
    var lbl = state.bModel ? state.bModel.label : null;
    if (lbl === tailleModele) return;
    tailleModele = lbl;

    var tailles = (state.bModel && state.bModel.tailles) || [];
    var plusieurs = tailles.length > 0;

    tailleSelect.innerHTML = '';
    if (plusieurs) {
      tailles.forEach(function (t) {
        var o = document.createElement('option');
        o.value = t;
        o.textContent = t;
        tailleSelect.appendChild(o);
      });
    }
    tailleSelect.hidden = !plusieurs;
    tailleSelect.disabled = !plusieurs;
    if (tailleUnique) tailleUnique.hidden = plusieurs;
    if (tailleNote) tailleNote.hidden = !plusieurs;
    tailleZone.hidden = !state.bModel;
  }
  function tailleChoisie() {
    return (tailleSelect && !tailleSelect.disabled) ? tailleSelect.value : '';
  }
  if (tailleSelect) tailleSelect.addEventListener('change', function () { refresh(); });
  if (tailleSpecs) {
    tailleSpecs.addEventListener('click', function () {
      if (state.bModel) focusSheet('bracelet', state.bModel.label);
    });
  }

  /* ---------------- Champ de gravure ----------------
     Pilote par le metafield custom.personnalisable de la piece choisie.
     `disabled` quand la piece ne s'y prete pas : un champ desactive n'est pas
     soumis, donc aucune propriete "Gravure" vide ne se glisse dans les autres
     commandes. */
  function majGravure() {
    if (!gravZone || !gravInput) return;
    var piece = null;
    if (state.bModel && state.bModel.perso) piece = state.bModel;
    else if (state.mModel && state.mModel.perso) piece = state.mModel;
    var actif = !!piece;
    gravZone.hidden = !actif;
    gravInput.disabled = !actif;
    if (!actif) gravInput.value = '';
  }

  /* ---------------- Ajout suggere ----------------
     Le produit propose se regle dans la section (aujourd'hui le paquet cadeau
     en tissu). Aucun champ du bloc upsell ne porte de `name` : le POST
     n'accepte qu'un seul produit, ces champs ne doivent donc rien y ajouter.

     L'AJOUT AU PANIER EST CELUI DU THEME. Le formulaire est enveloppe dans
     <product-form>, qui poste en AJAX, rafraichit les sections et ouvre le
     tiroir de panier. On ne reimplemente rien de tout ca : sans cet element le
     formulaire partait en POST classique et le client atterrissait sur /cart au
     lieu du mini-panier.

     Quand la case est cochee, on ajoute D'ABORD l'option par /cart/add.js, puis
     on relance l'envoi et <product-form> ajoute le coffret et ouvre le tiroir.
     Le drapeau evite de re-entrer dans ce handler a la relance.
     Si l'ajout de l'option echoue, on continue quand meme avec le coffret :
     mieux vaut une commande sans l'option qu'une page bloquee.

     L'ECOUTE SE FAIT SUR document, EN PHASE DE CAPTURE. <product-form> ecoute
     l'envoi directement sur le formulaire, et son ecouteur est pose avant ce
     script : un ecouteur ajoute lui aussi sur le formulaire passait apres lui,
     le coffret etait donc ajoute une premiere fois avant qu'on ait pu bloquer
     l'envoi, puis une seconde fois a la relance (2 coffrets au panier).
     En capture sur document on passe avant, et stopPropagation empeche
     l'evenement d'atteindre le formulaire.

     Cocher la case change aussi ce qu'on s'apprete a payer : le bouton et le
     prix de la barre collante affichent le total des deux lignes. Un bouton qui
     annonce 99,90 € alors que le panier en prendra 105,80 € est une mauvaise
     surprise au checkout. Le debut du libelle vient du reglage "Texte du bouton
     quand la case est cochee" (attribut data-cta). */
  var upsellZone = root.querySelector('[data-lbdh-upsell]');
  var upsellCheck = root.querySelector('[data-lbdh-upsell-check]');
  var upsellOpt = root.querySelector('[data-lbdh-upsell-opt]');
  var upsellSelect = root.querySelector('[data-lbdh-upsell-select]');
  var upsellCents = upsellZone ? (parseInt(upsellZone.getAttribute('data-prix'), 10) || 0) : 0;
  var upsellCta = (upsellZone && upsellZone.getAttribute('data-cta')) || 'Ajouter coffret + option';
  var form = root.querySelector('#lbdh-coffret-form');

  function optionAjoutee() {
    return !!(upsellCheck && upsellCheck.checked && upsellSelect && upsellSelect.value);
  }

  if (upsellCheck) {
    upsellCheck.addEventListener('change', function () {
      if (upsellZone) upsellZone.classList.toggle('is-on', upsellCheck.checked);
      if (upsellOpt) upsellOpt.hidden = !upsellCheck.checked;
      refresh();
    });
  }

  var optionEnCours = false;
  if (form) {
    document.addEventListener('submit', function (e) {
      if (e.target !== form) return;
      // Sans option, on ne touche a rien : <product-form> fait tout le travail.
      if (optionEnCours || !optionAjoutee()) return;
      e.preventDefault();
      e.stopPropagation();

      var declencheur = e.submitter || null;
      optionEnCours = true;
      ctas.forEach(function (b) { b.disabled = true; });

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(upsellSelect.value), quantity: 1 }] })
      }).then(function (r) {
        if (!r.ok) console.warn('[LBDH coffret] option non ajoutee, statut ' + r.status);
      }).catch(function () {
        console.warn('[LBDH coffret] option non ajoutee, erreur reseau');
      }).then(function () {
        ctas.forEach(function (b) { b.disabled = false; });
        try {
          if (form.requestSubmit) form.requestSubmit(declencheur || undefined);
          else form.submit();
        } catch (err) {
          if (form.requestSubmit) form.requestSubmit();
          else form.submit();
        }
        optionEnCours = false;
      });
    }, true);
  }

  /* ---------------- Fiches caracteristiques ----------------
     Chaque fiche est un <details> replie. On l'ouvre quand le client demande a
     la voir, sinon il tombait sur un bloc ferme apres le defilement et devait
     cliquer une seconde fois. */
  function sheetOf(famille, nom) {
    return root.querySelector('[data-lbdh-sheet="' + famille + ':' + nom + '"]');
  }
  function showSheet(famille, nom) {
    root.querySelectorAll('[data-lbdh-sheet^="' + famille + ':"]').forEach(function (el) { el.hidden = true; });
    var el = sheetOf(famille, nom);
    if (el) el.hidden = false;
    if (hint) hint.hidden = !!(state.mModel || state.bModel);
  }
  function focusSheet(famille, nom) {
    var el = sheetOf(famille, nom);
    if (!el) return;
    if ('open' in el) el.open = true;
    el.scrollIntoView({ behavior: 'smooth', block: 'center' });
    el.classList.remove('is-flash');
    void el.offsetWidth;
    el.classList.add('is-flash');
  }
  function setSheetPick(famille, nom, fin) {
    var sheet = sheetOf(famille, nom);
    if (!sheet) return;
    var thumb = sheet.querySelector('[data-lbdh-sheet-thumb]');
    if (thumb && fin && fin.img) { thumb.src = fin.img; thumb.alt = nom + ' ' + fin.label; }
    var chosen = sheet.querySelector('[data-lbdh-sheet-chosen]');
    if (chosen) chosen.textContent = fin ? 'Finition choisie : ' + fin.label : '';
  }

  root.querySelectorAll('[data-lbdh-sheet]').forEach(function (sheet) {
    var famille = (sheet.getAttribute('data-lbdh-sheet') || '').split(':')[0];
    var corps = sheet.querySelector('.lbdh-sheet__corps') || sheet;
    var back = document.createElement('button');
    back.type = 'button';
    back.className = 'lbdh-cfg__more';
    back.style.marginTop = '14px';
    back.innerHTML = FLECHE_HAUT + 'Revenir à mon choix';
    back.addEventListener('click', function () {
      var g = root.querySelector('[data-lbdh-group="' + famille + '-modele"]');
      if (g) g.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
    corps.appendChild(back);
  });

  /* ---------------- Selecteurs ---------------- */
  function renderCards(groupName, famille, list, onPick) {
    var wrap = root.querySelector('[data-lbdh-group="' + groupName + '"]');
    if (!wrap) return;
    wrap.innerHTML = '';
    list.forEach(function (item) {
      var cell = document.createElement('div');
      cell.className = 'lbdh-cfg__cardwrap';

      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'lbdh-cfg__card';
      b.setAttribute('role', 'radio');
      b.setAttribute('aria-checked', 'false');
      var f0 = item.finitions[0] || {};
      var cover = f0.vignette || f0.img || '';
      b.innerHTML = '<img src="' + cover + '" alt="" loading="lazy">' +
                    '<b>' + item.label + '</b>' +
                    (item.sub ? '<small>' + item.sub + '</small>' : '') +
                    (item.perso ? '<em class="lbdh-cfg__cardperso">Gravable</em>' : '');
      vignettesCartes[famille][item.label] = b.querySelector('img');
      b.addEventListener('click', function () {
        wrap.querySelectorAll('[role="radio"]').forEach(function (n) { n.setAttribute('aria-checked', 'false'); });
        b.setAttribute('aria-checked', 'true');
        onPick(item);
      });

      var more = document.createElement('button');
      more.type = 'button';
      more.className = 'lbdh-cfg__more';
      more.innerHTML = 'Voir le détail' + FLECHE_BAS;
      more.setAttribute('aria-label', 'Voir le détail de ' + item.label);
      more.addEventListener('click', function () {
        if (b.getAttribute('aria-checked') !== 'true') b.click();
        focusSheet(famille, item.label);
      });

      cell.appendChild(b);
      cell.appendChild(more);
      wrap.appendChild(cell);
    });
  }

  function renderSwatches(groupName, item, onPick) {
    var wrap = root.querySelector('[data-lbdh-group="' + groupName + '"]');
    if (!wrap) return;
    wrap.innerHTML = '';
    item.finitions.forEach(function (f) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'lbdh-cfg__sw';
      b.setAttribute('role', 'radio');
      b.setAttribute('aria-checked', 'false');
      b.innerHTML = '<img src="' + (f.vignette || f.img || '') + '" alt="" loading="lazy"><span>' + f.label + '</span>';
      b.addEventListener('click', function () {
        wrap.querySelectorAll('[role="radio"]').forEach(function (n) { n.setAttribute('aria-checked', 'false'); });
        b.setAttribute('aria-checked', 'true');
        onPick(f);
      });
      wrap.appendChild(b);
    });

    /* On selectionne TOUJOURS la premiere finition, celle que remonte le
       reglage "Finition a mettre en premier". Sans ca, cliquer une montre
       laissait la combinaison incomplete : l'apercu n'avait plus de coffret a
       montrer et retombait sur le packshot de cette montre, exactement ce que
       le visuel principal est cense ne jamais faire. Le client voit maintenant
       son coffret avec la nouvelle piece des le premier clic, et change la
       finition ensuite s'il le souhaite. */
    var premier = wrap.querySelector('[role="radio"]');
    if (premier) premier.click();
  }

  function setStep(n, statusClass) {
    var el = steps[String(n)];
    if (!el) return;
    el.classList.remove('is-locked', 'is-done');
    if (statusClass) el.classList.add(statusClass);
  }

  /* Tant que la preselection n'est pas terminee, on ne touche pas a l'apercu :
     les quatre clics simules passeraient par trois etats intermediaires et
     feraient telecharger trois images pour rien avant la bonne. */
  var pret = false;

  function refresh() {
    var done = state.mModel && state.mFin && state.bModel && state.bFin;
    var avecOption = optionAjoutee();
    var totalCents = priceCents + (avecOption ? upsellCents : 0);

    var label = 'Choisissez votre montre pour commencer';
    if (state.mModel && !state.mFin) label = 'Choisissez la finition de la montre';
    else if (state.mFin && !state.bModel) label = 'Choisissez maintenant le bracelet';
    else if (state.bModel && !state.bFin) label = 'Choisissez la finition du bracelet';

    majTaille();
    majGravure();
    if (pret) majApercu();
    var taille = tailleChoisie();

    if (stickyPrix) stickyPrix.textContent = money(totalCents);

    if (recap) {
      recap.hidden = !(state.mModel || state.bModel);
      root.querySelector('[data-lbdh-recap-montre]').textContent = state.mModel
        ? 'Montre ' + state.mModel.label + (state.mFin ? ' — ' + state.mFin.label : ' — finition à choisir')
        : 'Montre — à choisir';
      root.querySelector('[data-lbdh-recap-bracelet]').textContent = state.bModel
        ? 'Bracelet ' + state.bModel.label +
          (state.bFin ? ' — ' + state.bFin.label : ' — finition à choisir') +
          (taille ? ' — ' + taille : '')
        : 'Bracelet — à choisir';
      if (recapLis[0]) recapLis[0].classList.toggle('is-pending', !state.mFin);
      if (recapLis[1]) recapLis[1].classList.toggle('is-pending', !state.bFin);
      if (valueRow) valueRow.hidden = true;
    }

    if (done) {
      var v = DATA.variants[state.mFin.opt + '||' + state.bFin.opt];
      if (v && v.ok) {
        sel.value = String(v.id);
        sel.dispatchEvent(new Event('change', { bubbles: true }));
        label = avecOption
          ? upsellCta + ' ' + money(totalCents)
          : 'Ajouter ce coffret ' + money(priceCents);
        var sum = Math.round(parseFloat(state.mFin.price) + parseFloat(state.bFin.price));
        var eco = sum - priceCents;
        root.querySelector('[data-lbdh-sum]').textContent = money(sum);
        root.querySelector('[data-lbdh-save]').textContent = money(eco);
        if (valueRow) valueRow.hidden = eco < ECO_MINI;

        if (vignetteM) { vignetteM.src = state.mFin.vignette || state.mFin.img; vignetteM.alt = state.mModel.label; }
        if (vignetteB) { vignetteB.src = state.bFin.vignette || state.bFin.img; vignetteB.alt = state.bModel.label; }
        var st = root.querySelector('[data-lbdh-sticky-recap]');
        if (st) st.textContent = state.mModel.label + ' + ' + state.bModel.label;
      } else {
        done = false;
        label = 'Cette combinaison est indisponible';
      }
    }

    var sticky = root.querySelector('[data-lbdh-sticky]');
    if (sticky) sticky.classList.toggle('is-ready', !!done);

    ctas.forEach(function (b) { b.disabled = !done; });
    ctaLabels.forEach(function (s) {
      s.textContent = estCourt(s) ? 'Ajouter' : label;
    });
  }

  renderCards('montre-modele', 'montre', DATA.montres, function (item) {
    state.mModel = item; state.mFin = null;
    setStep(1, 'is-done'); setStep(2, null);
    showSheet('montre', item.label);
    setSheetPick('montre', item.label, null);
    renderSwatches('montre-finition', item, function (f) {
      state.mFin = f;
      setStep(2, 'is-done'); setStep(3, null);
      setSheetPick('montre', item.label, f);
      majVignetteCarte('montre', item.label, f);
      refresh();
    });
    refresh();
  });

  renderCards('bracelet-modele', 'bracelet', DATA.bracelets, function (item) {
    state.bModel = item; state.bFin = null;
    setStep(3, 'is-done'); setStep(4, null);
    showSheet('bracelet', item.label);
    setSheetPick('bracelet', item.label, null);
    renderSwatches('bracelet-finition', item, function (f) {
      state.bFin = f;
      setStep(4, 'is-done');
      setSheetPick('bracelet', item.label, f);
      majVignetteCarte('bracelet', item.label, f);
      refresh();
    });
    refresh();
  });

  /* ---------------- Preselection au chargement ----------------
     Sans elle, le premier ecran mobile n'est que deux cadres vides : pas de
     produit, etapes 2 a 4 grisees, bouton inactif. Un visiteur venu d'une pub y
     lit une page cassee avant d'avoir compris l'offre.
     Les finitions se selectionnent toutes seules (voir renderSwatches), il ne
     reste donc que les deux modeles a cliquer.
     L'image rendue cote serveur par la section doit correspondre a la
     combinaison obtenue ici, sinon la page en affiche une puis saute a l'autre.
     Pour revenir a une page vide : commenter le bloc ci-dessous. */
  function premierDe(groupe) {
    return root.querySelector('[data-lbdh-group="' + groupe + '"] [role="radio"]');
  }
  var m0 = premierDe('montre-modele'); if (m0) m0.click();
  var b0 = premierDe('bracelet-modele'); if (b0) b0.click();

  pret = true;
  refresh();
})();